import type { FunctionComponent } from "react";

export const HolmanLogo: FunctionComponent = () => {
  return (
    <img
      src="/images/brand/holman.png"
      className={"w-32 md:w-[161px] max-h-[40px] object-contain"}
      alt="Holman"
    />
  );
};
